module.exports = __webpack_public_path__ + "static/media/quality2.cffbb33a.png";